export const DRAWER_KEYS = Object.freeze({
  creation: 'isCreationSavedSearchDrawerOpen',
  edit: 'isEditSavedSearchDrawerOpen',
  list: 'isSavedSearchDrawerOpen'
});
